/* src/app/modules/institutions/institutions-discounts/institutions-discounts.component.scss */
/*# sourceMappingURL=institutions-discounts.component.css.map */
